import React, { FC } from 'react';

import { Svg } from '@lglp/components';

import styles from './FacebookIcon.module.scss';

const FacebookIcon: FC<FacebookIconProps> = ({ className, ...rest }) => {
  return (
    <Svg
      className={[styles.facebookIcon, className]}
      viewBox="0 0 44 44"
      {...rest}
    >
      <circle
        data-name="Ellipse 209"
        cx="22"
        cy="22"
        r="22"
        style={{ fill: '#fff' }}
      />
      <path
        data-name="Tracé 4773"
        d="M81.8 17.7h-1.4c-1 0-1 .4-1 1.1V20h2.5l-.2 2.5h-2.3V30h-3.1v-7.6h-1.6v-2.6h1.6v-1.5c0-2.1 1-3.3 3.5-3.3a10.7 10.7 0 0 1 2.3.3z"
        transform="translate(-56.7 -1.002)"
        style={{ fill: '#003da5' }}
      />
    </Svg>
  );
};

type FacebookIconProps = {
  className?: string;
};

export default FacebookIcon;
